import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import IconFace from "@mui/icons-material/Face";
import IconVerifiedUser from "@mui/icons-material/VerifiedUser";
import { useMediaQuery, useTheme } from "@mui/material";
import { UiAvatar, UiBox, UiButton, UiTypography } from "@smp/ui";
import { testAppendAttr } from "@smp/utils";
import clsx from "clsx";
import { useCallback, useMemo, useState } from "react";

import { useSmpAcademyProgressRetrieve } from "@/hooks/use_smp_academy_progress";
import { useContextApp } from "@/screens/app/context/app";

import { useStyles } from "./controls_user.css";
import { MenuUser } from "./menu_user";

export const ControlsUser = () => {
  const {
    state: {
      me: { email, first_name: firstName, last_name: lastName },
    },
  } = useContextApp();
  const { i18n } = useLingui();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [$anchor, set$Anchor] = useState<null | HTMLElement>(null);
  const classes = useStyles();
  const { academyProgress } = useSmpAcademyProgressRetrieve();
  const isAcademyPassed = academyProgress?.is_academy_passed;

  const handleMenuOpen = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      set$Anchor(event.currentTarget);
    },
    [],
  );

  const handleMenuClose = useCallback(() => {
    set$Anchor(null);
  }, []);

  return useMemo(
    () => (
      <>
        <UiButton
          className={classes.button}
          onClick={handleMenuOpen}
          {...testAppendAttr("id", "header_controls_user")}
        >
          <UiBox flexGrow={0}>
            <UiAvatar
              alt={
                firstName && lastName
                  ? `${firstName} ${lastName}`
                  : i18n._(t`User avatar`)
              }
              className={clsx(classes.avatar, {
                [classes["avatar--academy_passed"]]: isAcademyPassed,
              })}
            >
              {!isAcademyPassed && <IconFace />}
              {isAcademyPassed && <IconVerifiedUser />}
            </UiAvatar>
          </UiBox>

          {!isMobile && (
            <UiBox
              display="flex"
              alignItems="flex-start"
              flexDirection="column"
              flexGrow={1}
              flexShrink={1}
              overflow="hidden"
              ml={2}
            >
              <UiBox flexGrow={1} width="100%" title={email} overflow="hidden">
                <UiTypography
                  align="left"
                  className={classes.button__header}
                  noWrap
                  variant="subtitle1"
                  textOverflow="ellipsis"
                >
                  {email}
                </UiTypography>
              </UiBox>
              <UiBox flexGrow={1} marginTop={0.25} width="100%">
                <UiTypography
                  align="left"
                  className={classes.button__footer}
                  noWrap
                  variant="subtitle2"
                  textOverflow="ellipsis"
                >
                  {firstName} {lastName}
                </UiTypography>
              </UiBox>
            </UiBox>
          )}
        </UiButton>
        <MenuUser $anchor={$anchor} marginTop={48} onClose={handleMenuClose} />
      </>
    ),
    [
      $anchor,
      classes,
      email,
      firstName,
      handleMenuClose,
      handleMenuOpen,
      i18n,
      isAcademyPassed,
      lastName,
      isMobile,
    ],
  );
};
